import { ChangeDetectionStrategy, Component, effect, input, model, output } from '@angular/core';
import { AppConfig } from 'src/app/app-config.loader';
import { AnagraficheService } from 'src/app/core/anagrafiche.service';
import { autocompleteFilter } from 'src/app/shared/helpers/autocompleteFilter.helper';
import { CisAllegato } from 'src/app/shared/models/cisAllegato.model';
import { Classifica } from 'src/app/shared/models/classifica.model';
import { Qualifica } from 'src/app/shared/models/qualifica.model';

@Component({
  selector: 'app-add-allegato-cis-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
 <p-dialog header="Allegati CIS" [(visible)]="visible" [modal]="true" (onHide)="hide.emit($event)" [style]="{'width':'50%'}">
    <div class="grid">
      <div class="col-12">
        <label for="tipoCIS" class="small-label">TipoCIS</label>
        <p-autoComplete inputId="tipoCIS" [(ngModel)]="tipoCIS" [suggestions]="elencoCISFiltrati" [style]="{'width':'40%'}"
           [dropdown]="true" (completeMethod)="filterCIS($event)" [forceSelection]="false" [autoHighlight]="true" appendTo="body" [disabled]="isUpdate">
        </p-autoComplete>
      </div>
      <div class="col-6">
        <label for="ricevente" class="small-label">Ricevente</label>
        <input id="ricevente" class="width-fill-available" pInputText type="text" [(ngModel)]="ricevente" [disabled]="isUpdate">
      </div>
      <div class="col-6">
        <label for="firma" class="small-label">Firma</label>
        <input id="firma" class="width-fill-available" pInputText type="text" [(ngModel)]="firma" [disabled]="isUpdate">
      </div>
      <div class="col-8">
        <label for="riproduzione" class="small-label">Riproduzione</label>
        <input id="riproduzione" class="width-fill-available" pInputText type="text" [(ngModel)]="riproduzione" [disabled]="isUpdate" maxlength="500">
      </div>
      <div class="col-4">
        <label for="numeroCopie" class="small-label">Numero copie</label>
        <input id="numeroCopie" class="width-fill-available" pInputText [(ngModel)]="numeroCopie" [disabled]="isUpdate" maxlength="50" />
      </div>
    </div>
      <hr>
    <div class="grid">
      <div class="col-6">
      <label for="classifica" class="small-label">Classifica</label>
        <p-autoComplete id="classifica" [suggestions]="classificheFiltrate" [delay]="20" [(ngModel)]="classifica" [style]="{'width':'100%'}"
      (completeMethod)="classificheFiltrate = autocompleteFilter($event,classifiche,'nomeClassifica')" [dropdown]="true" [size]="20" appendTo="body"
      dataKey="classificaId" [forceSelection]="true" field="nomeClassifica" [autoHighlight]="true" [required]="true" [inputStyle]="{'width': '187px'}">
    </p-autoComplete>
      </div>
      <div class="col-6">
      <label for="qualifica" class="small-label">Qualifica</label>
        <p-autoComplete id="qualifica" [suggestions]="qualificheFiltrate" [delay]="20" [(ngModel)]="qualifica" [style]="{'width':'100%'}"
      (completeMethod)="qualificheFiltrate = autocompleteFilter($event,qualifiche,'nomeQualifica')" [dropdown]="true" [size]="20" appendTo="body"
      dataKey="qualificaId" [forceSelection]="true" field="nomeQualifica" [autoHighlight]="true" [required]="true" [inputStyle]="{'width': '187px'}">
    </p-autoComplete>
      </div>
      <div class="col-12">
        <label for="note" class="small-label">Note</label>
        <input id="note" class="width-fill-available" pInputText type="text" [(ngModel)]="note" [disabled]="isUpdate">
      </div>
      <div class="col-12">
        <label for="annotazioni" class="small-label">Annotazioni</label>
        <textarea  id="annotazioni" class="width-fill-available" pInputTextarea rows="5" [(ngModel)]="annotazioni"></textarea>
      </div>
    </div>
    <p-footer>
      <button pButton type="button" icon="pi pi-times" label="Annulla" (click)="hideDialog()"
        class="p-button-secondary"></button>
      <button pButton type="button" icon="pi pi-check" label="Salva" (click)="save()" [disabled]="!tipoCIS || !classifica"></button>
    </p-footer>
  </p-dialog>
  `,
  styles: [`
    label { margin-bottom: 4px; margin-top: 20px; color: inherit; }
    label:first-of-type { margin-top: 0; }
    .width-fill-available{ width: 100% }
  `]
})

export class AddAllegatoCISDialogComponent {

  visible = model<boolean>(false);
  arrivo = model<boolean>(false);
  allegatoCIS = input<CisAllegato | undefined>();
  classificaDocumentoPadre = input<Classifica>();
  qualificaDocumentoPadre = input<Qualifica>();
  hide = output();
  saved = output<SaveAllegatoCisEvent>();

  public tipoCIS = '';
  public ricevente = '';
  public firma = '';
  public riproduzione = '';
  public classifica: Classifica | undefined;
  public qualifica: Qualifica | undefined;
  public elencoTipiCISStandard: string[] = [];
  public elencoCISFiltrati: string[] = [];
  public classifiche: Classifica[] = [];
  public qualifiche: Qualifica[] = [];
  public classificheFiltrate: Classifica[] = [];
  public qualificheFiltrate: Qualifica[] = [];
  public note = '';
  public annotazioni = '';
  public numeroCopie = '';
  public autocompleteFilter = autocompleteFilter;

  private classificaIdCorrente: number | undefined;

  public isUpdate = false;

  constructor(
    anagraficheService: AnagraficheService,
    private readonly appConfig: AppConfig,
  ) {
    anagraficheService.classifiche.getAllArray(u => this.classifiche = u);
    anagraficheService.qualifiche.getAllArray(u => this.qualifiche = u);

    this.elencoTipiCISStandard = [
      'CD',
      'DVD',
      'Pennetta USB',
      'Hard Disk',
      'Smart Card'
    ]

    effect(() => {
      if (this.visible()) {
        this.resetFields();
        this.fillData();
      }
    });
  }

  hideDialog(): void {
    this.hide.emit();
  }

  private resetFields() {
    this.isUpdate = false;
    this.tipoCIS = '';
    this.note = '';
    this.annotazioni = '';
    this.firma = '';
    this.riproduzione = '';
    this.numeroCopie = '';

    this.classifica = this.classificaDocumentoPadre();
    this.qualifica = this.qualificaDocumentoPadre();

    if (this.arrivo()) {
      this.ricevente = this.appConfig.text.registri.riceventeCIS;
    } else {
      this.ricevente = '';
    }
  }

  private fillData(): void {
    const allegatoCIS = this.allegatoCIS();

    if (allegatoCIS) {
      this.isUpdate = true;
      this.tipoCIS = allegatoCIS.tipoCIS;
      this.ricevente = allegatoCIS.caricoRicevente;

      const decodeClassifica = this.decodeClassifica(allegatoCIS.classifica);

      this.classifica = decodeClassifica.classifica;
      this.qualifica = decodeClassifica.qualifica;

      this.classificaIdCorrente = this.classifica?.classificaId;

      this.note = allegatoCIS.note;
      this.annotazioni = allegatoCIS.annotazioniUtente;

      this.firma = allegatoCIS.caricoFirma;
      this.riproduzione = allegatoCIS.riproduzione;
      this.numeroCopie = allegatoCIS.numeroCopie;
    }
  }

  private decodeClassifica(value: string): { classifica: Classifica | undefined, qualifica: Qualifica | undefined } {

    const result: { classifica: Classifica | undefined, qualifica: Qualifica | undefined } = { classifica: undefined, qualifica: undefined };
    const tokens = value.split(' ');
    let found = false;
    let i = 0;
    let classifica = '';

    do {
      classifica = (i === 0) ? tokens[i] : classifica + ' ' + tokens[i];

      const classificheFiltered = this.classifiche.filter(c => c.nomeClassifica.startsWith(classifica));
      if (classificheFiltered.length === 1) {
        found = true;
        result.classifica = classificheFiltered[0];
      }
      i++;
    } while (!found && i < tokens.length);

    if (found && result.classifica) {
      let qualifica = value.replace(`${result.classifica.nomeClassifica} `, '').trim();
      result.qualifica = this.qualifiche.find(q => q.nomeQualifica === qualifica);
    }
    return result;
  }

  save(): void {
    if (!this.classifica || !this.qualifica) return;

    const event: SaveAllegatoCisEvent = {
      tipoCIS: this.tipoCIS,
      ricevente: this.ricevente,
      classifica: this.classifica,
      qualifica: this.qualifica,
      note: this.note,
      annotazioniUtente: this.annotazioni,
      firma: this.firma,
      riproduzione: this.riproduzione,
      source: this.allegatoCIS(),
      numeroCopie: this.numeroCopie,
      classificaIdCorrente: this.classificaIdCorrente
    };

    this.saved.emit(event);
    this.hideDialog();
  }

  filterCIS(event: { query: string }): void {
    let filtered: string[] = [];
    if (event.query) {
      filtered = this.elencoTipiCISStandard.filter(cis => cis.toLowerCase().includes(event.query.toLowerCase()));
    } else {
      filtered = this.elencoTipiCISStandard;
    }

    this.elencoCISFiltrati = [...filtered];
  }
}

export interface SaveAllegatoCisEvent {
  tipoCIS: string;
  ricevente: string;
  classifica: Classifica;
  qualifica: Qualifica;
  note: string;
  annotazioniUtente: string;
  firma: string;
  riproduzione: string;
  source: CisAllegato | undefined;
  numeroCopie: string;
  classificaIdCorrente: number | undefined;
}
